// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFoundPage_NotFound__2wZ3c","card":"NotFoundPage_card__hedRg","code":"NotFoundPage_code__158N5","homeLink":"NotFoundPage_homeLink__3cEXi"};